import { gql } from "apollo-boost";

const queryFields = gql`
  query fields($limit: Int!, $offset: Int!, $sort: FieldsSort) {
    fields(filter: {
      limit: $limit
      offset: $offset
      sort: $sort
    }) {
      edges {
        node {
          guid
          id
          applicationGroup
          key
          title
          isVisible
          visibleOnBooking
          visibleOnJob
          description
          parentId
          parentKey
          sortOrder
          defaults
          custom,
          allowFreeEntry
          deletedAt
          emailTemplateGuid
        }
      },
      totalCount
    }
  }
`;

export {
  queryFields
};
